/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Box } from "@material-ui/core";
import { TitleDivider } from "./titleDivider";
import { ItemDisplay } from "./itemDisplay";
import { PropertyStatusInformationStore } from "../stores/propertyStatusInformationStore";
import { observer } from "mobx-react";
import google from "../assets/google.png";
import map from "../assets/map.png";
import zillow from "../assets/zillow.png";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { createCurrencyField, createDateField } from "@roc/ui";
import { formatCurrencyField, formatDateField } from "../utils/utils";

const useStyles = makeStyles((theme: Theme) => ({
  imgLink: {
    width: "2.5rem",
    height: "2.5rem",
    cursor: "pointer"
  },
}));

interface PropertyStatusInformationProps {
  propertyStatusInformationStore: PropertyStatusInformationStore;
  readOnly?: boolean;
}

export const PropertyStatusInformation = observer(({ propertyStatusInformationStore, readOnly = false }: PropertyStatusInformationProps) => {

  const classes = useStyles();
  const formValues: any = propertyStatusInformationStore.getFlattenedValues();

  const handleClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <TitleDivider title="Property Status Information" />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        padding={2}
      >
        <Box display="flex" gridGap="2rem">
          <ItemDisplay label="Property Status" value={formValues.propertyStatus || "-"} />
          <ItemDisplay label="Sale Type" value={formValues.saleType || "-"} />
          <ItemDisplay label="Original List Date" value={formatDateField(formValues.originalListDate)} />
          <ItemDisplay label="Original List Price" value={formatCurrencyField(formValues.originalListPrice)} />
          <Box minWidth="12rem">
            {createDateField({
              label: 'Last Sale Date',
              fieldName: 'lastSaleDate',
              testId: 'lastSaleDate',
              store: propertyStatusInformationStore,
              standaloneLabel: false,
              disabled: readOnly
            })}
          </Box>
          <Box minWidth="12rem">
            {createCurrencyField({
              label: 'Last Sale Price',
              fieldName: 'lastSalePrice',
              testId: 'lastSalePrice',
              store: propertyStatusInformationStore,
              standaloneLabel: false,
              disabled: readOnly
            })}
          </Box>
        </Box>
        <Box display="flex" gridGap="0.5rem">
          <img src={google} alt="Google Logo" className={classes.imgLink} onClick={() => handleClick(formValues.googleLink)} />
          <img src={map} alt="Google maps Logo" className={classes.imgLink} onClick={() => handleClick(formValues.googleMapsLink)} />
          <img src={zillow} alt="Zillow Logo" className={classes.imgLink} onClick={() => handleClick(formValues.zillowLink)} />
        </Box>
      </Box>
    </>
  );
});
